import { render, staticRenderFns } from "./vbdatapicker.vue?vue&type=template&id=6d1ff6ef&scoped=true&"
import script from "./vbdatapicker.vue?vue&type=script&lang=js&"
export * from "./vbdatapicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1ff6ef",
  null
  
)

export default component.exports